import React from "react"
import CombinedBitRow from "../CombinedBitRow"
import { getBitValueFromHex } from '../BitValueCalculator'
import { getCombinedMeaning } from '../CombinedMeaningCalculator'
import { renderNormalRow } from './NormalRowRenderer'


export const renderTvrByte5Rows = (rows, byteIndex, builderData, currentHexValue, handleCellClick) => {
  const allRows = [];
  
  for (let bitPos = 8; bitPos >= 3; bitPos--) {
    const row = rows.find(r => r.bit === bitPos);
    if (row) {
      const bitValue = getBitValueFromHex(byteIndex, bitPos, currentHexValue, 'tvr');
      allRows.push(renderNormalRow({...row, value: bitValue}, byteIndex, true, handleCellClick));
    }
  }
  
  if (builderData?.byte5CombinedMap) {
    const combinedBits = [];
    for (let bit = 2; bit >= 1; bit--) {
      combinedBits.push({
        bit: bit,
        value: getBitValueFromHex(byteIndex, bit, currentHexValue, 'tvr')
      });
    }
    const combinedMeaning = getCombinedMeaning('2-1', 'tvr', byteIndex, builderData, currentHexValue);
    
    allRows.push(
      <CombinedBitRow
        key="combined-2-1"
        byteIndex={byteIndex}
        bits={combinedBits}
        meaning={combinedMeaning}
        onBitToggle={handleCellClick}
        title="RRP Status (bits 2-1)"
      />
    );
  }
  
  return allRows;
}
